module.exports = __webpack_public_path__ + "static/media/fa-regular-400.f5f2566b.woff2";